// extracted by mini-css-extract-plugin
export var container = "_cd-0";
export var popoverContent = "_cd-1";
export var tosLink = "_cd-2";